import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, map, shareReplay } from 'rxjs';

// Trae el contenido de un .svg como texto e lo inlina en el DOM en vez de usar <img>.
// Asi el export a PDF (html2canvas) captura el SVG y evita requests repetidos por URL.
@Injectable({ providedIn: 'root' })
export class SvgIconService {
  private readonly cache = new Map<string, Observable<SafeHtml>>();

  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer
  ) {}

  get(src: string): Observable<SafeHtml> {
    let request$ = this.cache.get(src);

    if (!request$) {
      request$ = this.http.get(src, { responseType: 'text' }).pipe(
        map(svg => this.sanitizer.bypassSecurityTrustHtml(svg)),
        shareReplay(1)
      );

      this.cache.set(src, request$);
    }

    return request$;
  }
}
